export const withdrawnListings = {
  'web-summit-2028-2028': {
    title: 'EVENT LISTING WITHDRAWN',
    intro: 'This event listing has been removed.',
    sections: [
      {
        heading: 'Web Summit clarification',
        body: [
          'For the avoidance of doubt, Web Summit is not directly associated with the event as it was previously advertised on this page. The former listing was not an official Web Summit page and was not authorised or endorsed by Web Summit.',
          'Jigsaw Conferences Ltd and InternationalVenues.com are independent of Web Summit.',
        ],
      },
      {
        heading: 'About our service',
        body: [
          'Jigsaw Events Hub is an independent event-information service. Its primary purpose is to help eventgoers find and understand useful event-related data and plan their attendance.',
          'Jigsaw Events Hub is not an official event organiser or ticketing service. No affiliation with, authorisation from or endorsement by an event organiser should be assumed unless this is expressly confirmed on the relevant page.',
        ],
      },
      {
        heading: 'Questions about this notice',
        body: [
          'If you have a question about this withdrawal notice or information previously displayed on this page, please email it@jigsawconferences.co.uk and quote this page URL.',
          'For your security, please do not send unnecessary sensitive information.',
        ],
      },
    ],
  },
  'collision-toronto-2027-2027': {
    title: 'EVENT LISTING WITHDRAWN',
    intro: 'This event listing has been removed.',
    sections: [
      {
        heading: 'Web Summit clarification',
        body: [
          'For the avoidance of doubt, Web Summit is not directly associated with the Toronto event previously advertised on this page. Web Summit did not organise, authorise, sponsor or endorse that event or its publication by Jigsaw Conferences Ltd.',
          'The former listing was not an official Web Summit page. Jigsaw Conferences Ltd and InternationalVenues.com are independent of Web Summit.',
        ],
      },
      {
        heading: 'About our service',
        body: [
          'Jigsaw Events Hub is an independent event-information service. Its primary purpose is to help eventgoers find and understand useful event-related data and plan their attendance.',
          'Jigsaw Events Hub is not an official event organiser or ticketing service. No affiliation with, authorisation from or endorsement by an event organiser should be assumed unless this is expressly confirmed on the relevant page.',
        ],
      },
      {
        heading: 'Questions about this notice',
        body: [
          'If you have a question about this withdrawal notice or information previously displayed on this page, please email it@jigsawconferences.co.uk and quote this page URL.',
          'For your security, please do not send unnecessary sensitive information.',
        ],
      },
    ],
  },
};

export const getWithdrawnListing = (slug) => withdrawnListings[slug] || null;